/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const StationsFiltersTypeEnum10 = {
    STATION_TYPE: "STATION_TYPE"
} as const;

export type StationsFiltersTypeEnum10Key = (typeof StationsFiltersTypeEnum10)[keyof typeof StationsFiltersTypeEnum10];

export const StationsFiltersValueEnum4 = {
    STANDALONE: "STANDALONE",
    HEADER: "HEADER",
    REPEATER: "REPEATER",
    AFFILIATE: "AFFILIATE"
} as const;

export type StationsFiltersValueEnum4Key = (typeof StationsFiltersValueEnum4)[keyof typeof StationsFiltersValueEnum4];

export const StationsFiltersTypeEnum11 = {
    STATION_GROUP: "STATION_GROUP"
} as const;

export type StationsFiltersTypeEnum11Key = (typeof StationsFiltersTypeEnum11)[keyof typeof StationsFiltersTypeEnum11];

export const StationsFiltersTypeEnum12 = {
    STATION_INDIVIDUAL: "STATION_INDIVIDUAL"
} as const;

export type StationsFiltersTypeEnum12Key = (typeof StationsFiltersTypeEnum12)[keyof typeof StationsFiltersTypeEnum12];

/**
 * @description Data DTO for GIP report queries
*/
export type AuditReportsGipReportDataDto = {
    /**
     * @description The unique identifier of the client (required)
     * @type string, uuid
    */
    clientId: string;
    /**
     * @description Array of station IDs to query. Either this field or stationsFilters must be provided, but not both. Empty array will return all client stations.
     * @type array | undefined
    */
    stationsIds?: string[];
    /**
     * @description Array of station filters to apply. Either this field or stationsIds must be provided, but not both. Empty array will return all client stations.
     * @type array | undefined
    */
    stationsFilters?: ({
        /**
         * @type string
        */
        type: StationsFiltersTypeEnum10Key;
        /**
         * @type string
        */
        value: StationsFiltersValueEnum4Key;
    } | {
        /**
         * @type string
        */
        type: StationsFiltersTypeEnum11Key;
        /**
         * @type string, uuid
        */
        value: string;
    } | {
        /**
         * @type string
        */
        type: StationsFiltersTypeEnum12Key;
        /**
         * @minLength 1
         * @type string
        */
        value: string;
    })[];
    /**
     * @description Start date/time for the report period (ISO 8601 with or without timezone)
     * @type string
    */
    from: string;
    /**
     * @description End date/time for the report period (ISO 8601 with or without timezone)
     * @type string
    */
    to: string;
    /**
     * @description Array of campaign names to filter by
     * @type array | undefined
    */
    campaigns?: string[];
    /**
     * @description Array of advertiser names to filter by
     * @type array | undefined
    */
    advertisers?: string[];
    /**
     * @description Array of version identifiers to filter by
     * @type array | undefined
    */
    versions?: string[];
    /**
     * @description Custom key-value pairs for additional filtering
     * @default [object Object]
     * @type object | undefined
    */
    customFields?: {
        [key: string]: string;
    };
    /**
     * @description Array of audio IDs to filter by
     * @type array | undefined
    */
    audioIds?: string[];
    /**
     * @description Array of custom IDs to filter by
     * @type array | undefined
    */
    customIds?: string[];
    /**
     * @description Array of order identifiers to filter by
     * @type array | undefined
    */
    orders?: string[];
    /**
     * @description Array of match IDs to exclude from the report
     * @type array | undefined
    */
    excludedMatches?: string[];
};